import { render } from "./About.vue?vue&type=template&id=49c7e00a&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=49c7e00a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49c7e00a"

export default script